import NetworkStatus from 'enums/networkStatus';

export interface NetworkSliceState {
  isRunning: boolean;
  status: null | NetworkStatus;
  offsetSeconds: number;
  responseTime: number;
}

export enum NetworkErrorMessage {
  NO_CHANGE = 'Request failed with status code 409',
}
